import { render, staticRenderFns } from "./OldRequest.vue?vue&type=template&id=1dc7c0e9&scoped=true&"
import script from "./OldRequest.vue?vue&type=script&lang=js&"
export * from "./OldRequest.vue?vue&type=script&lang=js&"
import style0 from "./OldRequest.vue?vue&type=style&index=0&id=1dc7c0e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc7c0e9",
  null
  
)

export default component.exports